import { Dispatch, SetStateAction } from "react";
import api from "../../../utils/api";
import { ENABLE_DISABLE_LOOKUP_ITEM } from "../../../utils/endpoints";
import { auxiliaresLookUps } from "../data/AuxiliaresLookUps";
import { fetchAuxiliaresData } from "../data/fetchAuxiliaresData";

export const handleOnChangeStateItem = async (
  id: number,
  enabled: boolean,
  table: string,
  setDataTable: Dispatch<SetStateAction<any[]>>,
  setOriginalDataTable: Dispatch<SetStateAction<any[]>>,
  addToast: (options: {
    title: string;
    description: string;
    status: "success" | "error";
  }) => void,
) => {
  const tableIndex = +table - 1;
  const entityType = auxiliaresLookUps[tableIndex].entityName;

  try {
    const response = await api.post(ENABLE_DISABLE_LOOKUP_ITEM, {
      entityType,
      id,
      enabled,
    });
    if (response.status === 200) {
      await fetchAuxiliaresData(tableIndex, setDataTable, setOriginalDataTable);
      addToast({
        title: "Sucesso",
        description: "Alterações Guardadas",
        status: "success",
      });
    } else {
      throw new Error();
    }
  } catch (error) {
    console.error("API Error:", error);
    addToast({
      title: "Erro",
      description: "Ocorreu um erro ao alterar o estado do item",
      status: "error",
    });
  }
};
